export default {
  namespaced: true,
  state: {
    ongoing: null,
    refetchOneOrder: null,
    refetchAllOrders: false,
    openOngoingDialog: false,
    intervalTime: 15000
  },
  mutations: {
    updateOngoingData(state, data) {
      state.ongoing = data
    },
    updateRefetchOneOrder(state, leadPid) {
      state.refetchOneOrder = leadPid
    },
    updateRefetchAllOrders(state, bool) {
      state.refetchAllOrders = bool
    },
    updateOpenOngoingDialog(state, bool) {
      state.openOngoingDialog = bool
    },
    dismissOngoingData(state, data) {
      const index = state.ongoing.findIndex(item => item.id === data.id)
      if (index >= 0) {
        state.ongoing.splice(index, 1)
      }
    }
  },
  getters: {
    getOngoingCount(state) {
      return state.ongoing ? state.ongoing.length : 0
    },
    getGroupedOngoingData(state) {
      if (!state.ongoing) {
        return null
      }
      // Group data by status
      return state.ongoing.reduce((group, data) => {
        const status = data.extra_data.ongoing_status
        group[status] = group[status] ?? []
        group[status].push(data)
        return group
      }, {})
    }
  }
}
